<!-- 最新动态 -->
<template>
  <div class="other-news">
    <div class="other-news-banner">
      <img :src="banner">
    </div>
    <div class="other-news-con">
      <h1>ALL AS ONE - MSP 4.0</h1>
      <div>
        <ul>
          <li>“曾经、现在、将来，我正努力变成你喜欢的样子”。经过一季的时间沉淀，迎来了新版 MSP 4.0，在成为你喜欢的产品路上，越走越远，越走越快，期望能为你带来更好的服务体验，带来更加优质的服务；同时也欢迎您在“问题反馈”提出宝贵的建议；</li><br />
          <li>
            新版主要改动如下：<br />
            全新界面设计，逻辑优化；<br />
            新增评论区、导师评价等功能；<br />
            整体的消息系统，邮件、微信、站内信；<br />
            更加丰富和全方位支持服务的“须知文档”、“服务支持”；
          </li>
        </ul>
        <!-- <div class="other-news-great">
          <div></div>
          <p>72人觉得很赞</p>
        </div>
        <div class="other-news-btn">
          <Button class="zlr-btn-default">上一篇</Button>
          <Button class="zlr-btn-primary">下一篇</Button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
// images
import banner from '@/assets/images/other/new-banner.svg'
// less
import './other.less'
export default {
  name: 'other-news',
  components: {},
  data () {
    return {
      banner
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
